import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { useContext } from 'react';
import classNames from 'classnames';
import { Medialink } from '../_api/MedialinksApi';
import { Node } from '../_api/TableOfContentsApi';
import ModalContext from '../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import MaterialModalHeader from './common/MaterialModalHeader';
import MedialinkContentType from '../_components/common/MedialinkContentType';

type Props = {
  id: string;
  medialink: Medialink;
  node: Node;
  url: string;
  width?: number;
  height?: number;
};

// TODO: there was a plan to migrate .org urls to .com but this hasn't happened at the current time.
// When this has happened will the type implementation be depracated ?
// (ask production coordinator)
export default function H5PModal({ id, medialink, node, url, width, height }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  const calculatedWidth = width || window.innerWidth - 3 * 16;

  const isFullScreen = (!width && !height) || (width || 0) > window.innerWidth - 3 * 16;

  return (
    <ModalDialog
      id={id}
      closeTitle={t('ACTIONS.CLOSE')}
      closeViaEscape
      closeOnClickOutside
      onClose={() => closeModal(id)}
      className={classNames('material-dialog', { 'custom-dimensions': width || height })}
      fullScreen={isFullScreen}
      width={`${calculatedWidth}px`}
    >
      <MaterialModalHeader
        title={medialink.name}
        description={node.description}
        contentType={<MedialinkContentType medialink={medialink} />}
      />
      <Dialog.Body data-testid="dialog-body" className={classNames({ 'overflow-y': isFullScreen })}>
        <iframe role="presentation" src={url} title={medialink.name} allow="fullscreen" width={width} height={height} />
      </Dialog.Body>
    </ModalDialog>
  );
}
